import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import {
  FormGroup,
  Label,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import AdminGroupEditMembersEditSelectItem from './MembersEditSelectItem';

import ErrorBoundary from '../../ErrorBoundary';

const AdminGroupEditMembersEditSelect = ({
  group,
  users,
  handleAddMember,
  usersLoading,
}) => {
  const intl = useIntl();

  const getOptions = () => {
    const options = [];
    users.filter(u => (!group.users.includes(u.uuid)))
      .forEach((u) => {
        options.push({
          uuid: u.uuid,
          name: u.name,
          email: u.email,
          avatar: u.avatar_url,
        });
      });

    return options;
  };

  const handleChange = (value) => {
    if (!value.uuid) {
      return;
    }
    handleAddMember(value.uuid);
  };

  return (
    <ErrorBoundary>
      <FormGroup>
        <Label className="group-members-add-label" htmlFor="inpAddGroupMembers">
          {intl.formatMessage({ defaultMessage: 'Add users to the Team' })}
        </Label>
        <Select
          id="inpAddGroupMembers"
          inputId="inpAddGroupMembersInput"
          name="addGroupMembers"
          className="group-members-select user-select"
          classNamePrefix="user-select"
          placeholder={intl.formatMessage({ defaultMessage: 'Type name or email...' })}
          getOptionValue={option => option.email}
          getOptionLabel={option => option.name}
          components={{ Option: AdminGroupEditMembersEditSelectItem }}
          isDisabled={usersLoading}
          isLoading={usersLoading}
          noOptionsMessage={() => (intl.formatMessage({ defaultMessage: 'Nothing found' }))}
          options={getOptions()}
          onChange={handleChange}
          value={null}
        />
      </FormGroup>
    </ErrorBoundary>
  );
};

AdminGroupEditMembersEditSelect.propTypes = {
  group: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
  usersLoading: PropTypes.bool.isRequired,
  handleAddMember: PropTypes.func.isRequired,
};

export default AdminGroupEditMembersEditSelect;
